import type { ExternalTableSchema } from '@packages/table-builder';

export const taxSetupTable: ExternalTableSchema = {
  metadata: {
    title: 'Tax Setup',
    entity: 'tax-setup',
    description: 'Configure tax items for your organization.',
  },
  dataSource: {
    endpoint: '/api/tax/api/app/tax-item/tax-item-list',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: { items: 'items', totalCount: 'totalCount' },
    requestParams: {
      Filter: 'table.searchText',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
      TaxPeriodId: 'filters.taxPeriodId',
      TaxApprovalStatusId: 'filters.taxApprovalStatusId',
      IncomeYTDTypeId: 'filters.type',
    },
    filters: [
      {
        name: 'taxPeriodId',
        semanticId: 'taxSetupFilterTaxPeriod',
        placeholder: 'Select Tax Period',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/tax/api/app/tax-period/tax-period',
          labelField: 'name',
          valueField: 'id',
        },
      },
      {
        name: 'taxApprovalStatusId',
        semanticId: 'taxSetupFilterTaxStatus',
        placeholder: 'Select Tax Status',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/tax/api/app/tax-item-approval/approval-list',
          labelField: 'displayName',
          valueField: 'id',
        },
      },
      {
        name: 'type',
        semanticId: 'taxSetupFilterIncomeYtd',
        placeholder: 'Select Income YTD',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/tax/api/app/tax-item/income-yTDTypes',
          labelField: 'name',
          valueField: 'id',
        },
      },
    ],
  },
  columns: [
    {
      field: 'taxPeriodName',
      header: 'Tax Period',
      type: 'coupleWithDateRange',
      width: 200,
      sortable: true,
      couple: { titleField: 'taxPeriodName', subtitleField: 'taxPeriodName' },
      dateRange: { startField: 'taxEffectiveFrom', endField: 'taxEffectiveTo' },
    },
    { field: 'name', header: 'Name', type: 'text', width: 200, sortable: true },
    { field: 'parentTaxItemIdName', header: 'Parent Tax', type: 'text', width: 180, sortable: true },
    { field: 'taxCode', header: 'Pay Code', type: 'text', width: 180, sortable: true },
    { field: 'jurisdictionName', header: 'Jurisdiction Level', type: 'text', width: 200, sortable: true },
    {
      field: 'equityCompensationLevelName',
      header: 'Applicable To',
      type: 'text',
      width: 180,
      sortable: true,
    },
    {
      field: 'incomeYtdTypeDisplayName',
      header: 'Income YTD Type',
      type: 'text',
      width: 200,
      sortable: true,
    },
    {
      field: 'statusDisplayName',
      header: 'Status',
      type: 'badge',
      width: 180,
      sortable: true,
      align: 'center',
      uppercase: true,
      badge: {
        statusMap: {
          Approved: 'success',
          Deactivated: 'error',
          Rejected: 'error',
          Created: 'primary',
        },
      },
    },
  ],
  actions: {
    toolbar: {
      buttons: [{ id: 'CREATE_TAX_SETUP', label: 'Create Tax Item', variant: 'primary' }],
      templates: [
        {
          label: 'Download Template',
          type: 'download',
          children: [{ id: 'DOWNLOAD_TEMPLATE_TAX_SETUP', label: 'Download Template' }],
        },
        {
          label: 'Import Bulk XLS',
          type: 'upload',
          children: [{ id: 'IMPORT_TAX_SETUP', label: 'Import Bulk XLS' }],
        },
      ],
    },
    row: [
      { id: 'VIEW_TAX_SETUP', label: 'View' },
      { id: 'EDIT_TAX_SETUP', label: 'Edit' },
      { id: 'COPY_TAX_SETUP', label: 'Make a Copy' },
      { id: 'ACTIVATE_TAX_SETUP', label: 'Activate' },
      { id: 'REQUEST_APPROVAL_TAX_SETUP', label: 'Request for Approval' },
      { id: 'OVERRIDE_TAX_SETUP', label: 'Override Tax' },
      { id: 'VIEW_COMMENT_TAX_SETUP', label: 'View Comment' },
      { id: 'DEACTIVATE_TAX_SETUP', label: 'Deactivate', variant: 'danger' },
      { id: 'DELETE_TAX_SETUP', label: 'Delete', variant: 'danger' },
    ],
    bulk: [{ id: 'BULK_EXPORT_TAX_SETUP', label: 'Bulk Export' }],
  },
  features: {
    search: { enabled: true, placeholder: 'Search…' },
    filterGrid: { columns: 2 },
    pagination: { mode: 'infiniteScroll', defaultSize: 10 },
    selection: { keyField: 'id' },
    import: { enabled: true },
  },
};
